module.exports = __webpack_public_path__ + "media/images/emergency-lighting-34f38e8382c194a8a044dc32d343a72d.svg";